export default __webpack_public_path__ + "static/media/Group 1.7bac787e.svg";